import { Component, ViewChild, Injector, Output, EventEmitter, OnInit, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { debounceTime, finalize, switchMap } from 'rxjs/operators';
import { CreateOrEditStockTakeDto, StockTakeServiceProxy, CreateOrUpdateStockTakeInput } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';
import { AppSessionService } from '../../../shared/common/session/app-session.service';

@Component({
    selector: 'createOrEditStockTakeModal',
    templateUrl: './create-or-edit-stocktake-modal.component.html',
    standalone: false,
})
export class CreateOrEditStockTakeModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    stockTake: CreateOrEditStockTakeDto = new CreateOrEditStockTakeDto();

    constructor(
        injector: Injector,
        private _stockTakeServiceProxy: StockTakeServiceProxy,
        private _dateTimeService: DateTimeService
    ) {
        super(injector);
    }

    ngOnInit(): void {}

    show(stockTakeId?: number): void {
        if (!stockTakeId) {
            this.stockTake = new CreateOrEditStockTakeDto();
            this.stockTake.id = stockTakeId;
            this.stockTake.stockTakeDate = this._dateTimeService.getStartOfDay();
            this.active = true;
            this.modal.show();
        } else {
            this._stockTakeServiceProxy.getStockTakeForEdit(stockTakeId).subscribe((result) => {
                this.stockTake = result.stockTake;

                this.active = true;
                this.modal.show();
            });
        }
    }

    save(): void {
        this.saving = true;
        this.stockTake.locationId = this.appSession.user.locationId;
        var stockTakeInput = new CreateOrUpdateStockTakeInput();
        stockTakeInput.stockTake = this.stockTake;
        this._stockTakeServiceProxy
            .createOrEditStockTake(stockTakeInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
            });
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
